var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("flexbox", { staticClass: "wk-upload-cell" }, [
    _c("img", {
      staticClass: "wk-upload-cell__header",
      attrs: { src: _vm.fileIcon },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wk-upload-cell__body" },
      [
        _c("div", { staticClass: "text-one-line" }, [
          _vm._v(_vm._s(_vm.file.name)),
          _c("span", { staticStyle: { color: "#999" } }, [
            _vm._v(_vm._s(_vm.fileSize)),
          ]),
        ]),
        _vm._v(" "),
        _c("el-progress", {
          attrs: {
            "stroke-width": 3,
            "show-text": false,
            percentage: _vm.complete ? 100 : _vm.percentage,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wk-upload-cell__footer" },
      [
        _c("el-button", {
          attrs: { icon: _vm.handleIcon },
          on: { click: _vm.cancelRequest },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }